import { render, staticRenderFns } from "./VehiclesBrandUpdateModal.vue?vue&type=template&id=fe4c3ca2&scoped=true"
import script from "./VehiclesBrandUpdateModal.vue?vue&type=script&lang=js"
export * from "./VehiclesBrandUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./VehiclesBrandUpdateModal.vue?vue&type=style&index=0&id=fe4c3ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4c3ca2",
  null
  
)

export default component.exports